import type {
  UseKeyboardResizeParams,
  UseKeyboardResizeReturn,
} from './index.types';
import * as React from 'react';
import { getWidthFromKeyboardKey } from '../../utils';

/**
 * Keyboard resize (ArrowLeft / ArrowRight / Home / End).
 * Each committed key press persists the new width.
 */
export const useKeyboardResize = ({
  disabled = false,
  handleSide,
  bounds,
  widthRef,
  persistWidth,
}: UseKeyboardResizeParams): UseKeyboardResizeReturn => {
  const handleKeyDown = React.useCallback(
    (event: React.KeyboardEvent<HTMLDivElement>) => {
      if (disabled) {
        return;
      }

      const nextWidth = getWidthFromKeyboardKey({
        key: event.key,
        currentWidth: widthRef.current,
        bounds,
        handleSide,
      });

      if (nextWidth === null) {
        return;
      }

      event.preventDefault();
      persistWidth(nextWidth);
    },
    [disabled, handleSide, bounds, persistWidth, widthRef]
  );

  return { handleKeyDown };
};
